import { Injectable } from '@angular/core';
import  normalize from 'json-api-normalize';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class CommentModel {
  public comment: string;
  public commentTimeStamp: string;

  constructor(values?: Partial<CommentModel>) {
    Object.assign(this, values);
  }
}

export class NoteModel {
  public static parseNoteJson(noteJson: any) {
    const fields = [
      'id',
      'title',
      'drupal_internal__nid',
      'changed',
      'field_fac_teaching_avail',
      'field_match_rank_order',
      'field_program_col',
      'field_program_comments',
      'field_program_community',
      'field_program_fit',
      'field_program_interview',
      'field_program_morale',
      'field_program_rating',
      'field_program_status',
      'field_program.field_program_id',
      'field_program.id',
      'field_program.title',
      'field_program.field_specialty.title'
    ];

    const normdNotes = normalize(noteJson).get(fields);
    const programNotes = (!Array.isArray(normdNotes) ? [ normdNotes ] : normdNotes).map((note: any) => {
      const noteModel = new NoteModel({
        uuid: note.id,
        programUuid: note.field_program.id,
        communityType: note.field_program_community,
        costOfLiving: note.field_program_col,
        culturePersonalityFit: note.field_program_fit,
        facultyTeachingAvailability: note.field_fac_teaching_avail,
        interviewDateTime: note.field_program_interview,
        matchRankOrder: note.field_match_rank_order,
        programNumber: note.field_program.field_program_id,
        rating: note.field_program_rating,
        residentsMorale: note.field_program_morale,
        status: note.field_program_status,
        programName: note.field_program.title,
        specialtyName: note.field_program.field_specialty.title
      });
      noteModel.comments = note.field_program_comments ?
        note.field_program_comments.map((c: any) => new CommentModel({ comment: c.comment, commentTimeStamp: c.value }))
        : [];

      return noteModel;
    });

    return of(programNotes);
  }

  public uuid: string;
  public title: string;
  public programNumber: string;
  public rating: number;
  public status: string;
  public interviewDateTime: string;
  public culturePersonalityFit: number;
  public residentsMorale: number;
  public facultyTeachingAvailability: number;
  public communityType: string;
  public costOfLiving: number;
  public matchRankOrder: number;
  public comments: CommentModel[];

  public programName: string;
  public specialtyName: string;
  public programUuid: string;

  constructor(values?: Partial<NoteModel>) {
    Object.assign(this, values);
    this.comments = [];
  }

  public isValid(): boolean {
    if (this.matchRankOrder) {
      return this.matchRankOrder > 0 && this.matchRankOrder < 100;
    }

    return true;
  }

  public get sortedComments(): CommentModel[] {
    return this.comments.sort((a: CommentModel, b: CommentModel) => {
      return a.commentTimeStamp.localeCompare(b.commentTimeStamp) * -1;
    });
  }
}
